import React, { useEffect, useState } from "react";
import CustomCharacterBookView from "./CustomCharacterBookView";
import "./HandPrint.css";
import Stepbar from "./Stepbar";
import { useHistory, Link } from "react-router-dom";
// Pages
import { useParams } from "react-router-dom";
import mixins from "../../app-services/mixins";
import Previewsteps from "./Previewsteps";
import PreventUnload from "./PreventUnload";

// TXT Pages
import Frontpage from "./txtpages/chapterone/frontpage.txt";
import Mainpage from "./txtpages/MainPage.txt";
import FrontCover from "./txtpages/frontCover.txt";
import CopyRight from "./txtpages/copyRight.txt";
import Ch4frontpage from "./txtpages/chapterfour/frontpage.txt";
import Ch4pageone from "./txtpages/chapterfour/pageone.txt";
import Ch4pagetwo from "./txtpages/chapterfour/pagetwo.txt";
import Ch4pagethree from "./txtpages/chapterfour/pagethree.txt";
import Ch4pagefour from "./txtpages/chapterfour/pagefour.txt";
import Ch4pagefive from "./txtpages/chapterfour/pagefive.txt";
import Ch4pagesix from "./txtpages/chapterfour/pagesix.txt";
import Ch4pageseven from "./txtpages/chapterfour/pageseven.txt";
import Ch4pageight from "./txtpages/chapterfour/pageight.txt";
import Ch4pagenine from "./txtpages/chapterfour/pagenine.txt";
import Ch5frontpage from "./txtpages/chapterfive/frontpage.txt";
import Ch7frontpage1 from "./txtpages/chapterseven/left.txt";
import Ch7frontpage2 from "./txtpages/chapterseven/frontpage.txt";
import Chfinalfrontpage from "./txtpages/finalchapter/frontpage.txt";
import Backcover from "./txtpages/backcover.txt";
import ChapterNineFrontpage from "./txtpages/chapternine/frontpage.txt";
import ChapterNineFrontpage2 from "./txtpages/chapternine/frontpage2.txt";
import { set } from "lodash";



const BookManage = (props) => {
    const history = useHistory();
    const { setShowModal, defaultdedication } = props;
    const customCharacter = props.store?.customCharacter || [];
    const { id, customBookId } = useParams();
    const [preinfoCompleted, setPreinfoCompleted] = useState(false);
    const worldbookPreInfo = props.store?.book?.customCharacter;
    const answer = worldbookPreInfo?.answer;
    const [pages, setPages] = useState([]);
    const [currentopenpage, setCurrentopenpage] = useState(0);
    const [customSvg, setCustomSvg] = useState({});
    const handlePreinfoSave = () => {
        console.log("Handle Pre Info Save.");
    };
    const fetchPages = async () => {
        try {
            let innerwidth = window.innerWidth;
            let width = 0;
            if (innerwidth > 768) {
                width = ((innerwidth * 0.5) / 2).toFixed(0);
            } else {
                width = ((innerwidth * 1) / 2).toFixed(0);
            }
            const pageUrls = [
                { backcover: Backcover },
                { frontcover: FrontCover },
                { mainpage: Mainpage },
                { copyRight: CopyRight },
                { frontpage: Frontpage },
                { ch4frontpage: Ch4frontpage },
                { ch4pageone: Ch4pageone },
                { ch4pagetwo: Ch4pagetwo },
                { ch4pagethree: Ch4pagethree },
                { ch4pagefour: Ch4pagefour },
                { ch4pagefive: Ch4pagefive },
                { ch4pagesix: Ch4pagesix },
                { ch4pageseven: Ch4pageseven },
                { ch4pageight: Ch4pageight },
                { ch4pagenine: Ch4pagenine },
                { ch5frontpage: Ch5frontpage },
                { ch7frontpage1: Ch7frontpage1 },
                { ch7frontpage2: Ch7frontpage2 },
                { chapterNineFrontpage: ChapterNineFrontpage },
                { chapterNineFrontpage2: ChapterNineFrontpage2 },
                { chfinalfrontpage: Chfinalfrontpage },
            ];
            const setpages = [
                {
                    name: `backcover`,
                    chapter: 1,
                    label: `1`,
                },
                {
                    name: `frontcover`,
                    chapter: 1,
                    label: `2`,
                },
                {
                    name: `mainpage`,
                    chapter: 1,
                    label: `3`,
                },
                {
                    name: `copyRight`,
                    chapter: 1,
                    label: `4`,
                },
                {
                    name: `frontpage`,
                    chapter: 1,
                    label: `5`,
                },
                {
                    name: `ch4frontpage`,
                    chapter: 4,
                    label: `6`,
                },
                {
                    name: `ch4pageone`,
                    chapter: 4,
                    label: `7`,
                },
                {
                    name: `ch4pagetwo`,
                    chapter: 4,
                    label: `8`,
                },
                {
                    name: `ch4pagethree`,
                    chapter: 4,
                    label: `9`,
                },
                {
                    name: `ch4pagefour`,
                    chapter: 4,
                    label: `10`,
                },
                {
                    name: `ch4pagefive`,
                    chapter: 4,
                    label: `11`,
                },
                {
                    name: `ch4pagesix`,
                    chapter: 4,
                    label: `12`,
                },
                {
                    name: `ch4pageseven`,
                    chapter: 4,
                    label: `13`,
                },
                {
                    name: `ch4pageight`,
                    chapter: 4,
                    label: `14`,
                },
                {
                    name: `ch4pagenine`,
                    chapter: 4,
                    label: `15`,
                },
                {
                    name: `ch5frontpage`,
                    chapter: 5,
                    label: `16`,
                },
                {
                    name: `ch7frontpage1`,
                    chapter: 7,
                    label: `17`,
                },
                {
                    name: `ch7frontpage2`,
                    chapter: 7,
                    label: `18`,
                },
                {
                    name: `chapterNineFrontpage`,
                    chapter: 9,
                    label: `19`,
                },
                {
                    name: `chapterNineFrontpage2`,
                    chapter: 9,
                    label: `20`,
                },
                {
                    name: `chfinalfrontpage`,
                    chapter: 1,
                    label: `21`,
                },
            ];
            const customCharacter = props.store?.customCharacter || [];
            const overlayStyle = getCustomCharacterStyles(customCharacter);
            const updatedSVG = await updateSVGs();
            const pagePromises = pageUrls.map(async (pageUrlObj) => {
                const pageKey = Object.keys(pageUrlObj)[0];
                const response = await fetch(pageUrlObj[pageKey]);
                const content = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(content, "text/html");
                doc.querySelectorAll('[id="custom_name"]').forEach((el) => {
                    el.innerHTML = overlayStyle["--fname"] || "";
                });
                doc.querySelectorAll('[id="first_name"]').forEach((el) => {
                    el.innerHTML = overlayStyle["--fname"] || "";
                });
                doc.querySelectorAll('[id="gender"]').forEach((el) => {
                    el.innerHTML = overlayStyle["--currentGender"] || "";
                });
                const genderVal = overlayStyle["--currentGender"];
                if (genderVal === "boy") {
                    doc
                        .querySelectorAll('[id="his"]')
                        .forEach((el) => (el.innerHTML = "his"));
                    doc
                        .querySelectorAll('[id="he"]')
                        .forEach((el) => (el.innerHTML = "he"));
                    doc
                        .querySelectorAll('[id="hecap"]')
                        .forEach((el) => (el.innerHTML = "He"));
                } else {
                    doc
                        .querySelectorAll('[id="his"]')
                        .forEach((el) => (el.innerHTML = "her"));
                    doc
                        .querySelectorAll('[id="he"]')
                        .forEach((el) => (el.innerHTML = "she"));
                    doc
                        .querySelectorAll('[id="hecap"]')
                        .forEach((el) => (el.innerHTML = "She"));
                }
                doc.querySelectorAll('[id="dedictaion_text"]').forEach((el) => {
                    el.innerHTML = overlayStyle["--dedictaion_text"] || defaultdedication;
                });
                const key = Object.keys(pageUrlObj)[0];
                const page = setpages.find((p) => p.name === key);
                if (page.chapter) {
                    let svgObj = updatedSVG[page.chapter];
                    let overlayData = doc.querySelector("#overlay-data");
                    if (overlayData && svgObj) {
                        let svg = overlayData.querySelector("svg,img");
                        if (svg) {
                            let svgStyle = svg?.style?.getStyle();
                            let styleString = Object.styleString(svgStyle);
                            svg.remove();
                            overlayData.innerHTML += `<img src="${svgObj.svgbase64}" style='${styleString}' />`;
                        }
                    }
                }
                return { [pageKey]: new XMLSerializer().serializeToString(doc) };
            });
            const pagesContent = await Promise.all(pagePromises);
            setPages(pagesContent);
        } catch (error) {
            console.error("Error fetching pages:", error);
        }
    };

    const handleClick = (componentname) => {
        setShowModal(componentname);
    };

    useEffect(() => {
        if (customCharacter?.length > 2) {
            handleClick("book");
        } else {
            handleClick("info");
        }
    }, [customBookId]);
    const getProductDetails = () => { };

    useEffect(() => {
        if (customBookId) {
            getLatestBook();
        }
        if (id) {
            getProductDetails();
        }
    }, [customBookId]);

    useEffect(() => {
        fetchPages();
    }, []);

    const getLatestBook = () => { };
    const processPages = (pages) => {
        const parser = new DOMParser();
        return pages.reduce((acc, item) => {
            const pageKey = Object.keys(item)[0];
            let doc = parser.parseFromString(item[pageKey], "text/html");
            let bookcontent = doc.body.innerHTML;
            acc[pageKey] = { html: bookcontent, png: "", base64: "" };
            return acc;
        }, {});
    };
    const addtocart = () => {
        let file = null;
        let payload = processPages(pages);
        const customCharacter = props.store?.customCharacter || [];
        const BOOKID = id;
        const dedication =
            props.store?.customCharacter[8]?.ans?.dedication ||
            `<p>Believe in yourself</p> <p>and dare to dream!</p> <p>You are always loved.</p>`;
        let firstNamevar = customCharacter[1]["ans"]["first_name"];
        let lastNamevar = customCharacter[1]["ans"]["last_name"];
        return new Promise((resolve, reject) => {
            let apiPayload = {
                file,
                bookId: BOOKID,
                savedBook: JSON.stringify(payload),
                option: "dynamic",
                sessionId: localStorage.getItem("sessionID") || null,
                type: "customcharacter",
                attributes: JSON.stringify(customCharacter),
                customcharacterpng: JSON.stringify(customSvg),
                firstname: firstNamevar,
                lastname: lastNamevar || null,
                gender: customCharacter[2]["ans"]["gender"],
                dedication: mixins.convertToHtmlEntities(dedication),
            };
            mixins.checkLogin(history).then(() => {
                console.log("Saving");
                if (customBookId) {
                    api.updateSelfPublish(apiPayload, customBookId).then((responce) => {
                        console.log(responce);
                        addtocardfunc(responce?.data);
                    });
                } else {
                    api.createSelfPublish(apiPayload).then((responce) => {
                        console.log(responce);
                        addtocardfunc(responce?.data);
                    });
                }
            });
        });
    };

    const savebookforlater = () => {
        console.log("Save for Later.");
    };

    const addtocardfunc = (responce) => {
        if (localStorage.getItem("editmode") === "true") {
            api
                .updateToCart(
                    {
                        promotionId: null,
                        productId: props.store.product.id,
                        quantity: 1,
                        price: props.store.product.actualPrice,
                        discount: null,
                        bookCover: null,
                        customProductId: props.store.cartdetails?.customProductId,
                    },
                    props.store.cartdetails?.id
                )
                .then((res) => {
                    localStorage.setItem("editmode", false);
                    if (res && res.statusCode === 200) {
                        history.push("/checkout-page");
                    } else {
                        alert("Something went wrong please try again later..");
                    }
                });
        } else {
            mixins.reFectchSavedBookDetails(props);
            api
                .addToCart({
                    promotionId: null,
                    productId: props.store.product.id,
                    quantity: 1,
                    customBookId: responce?.customBook?.id,
                    price: props.store.product.actualPrice,
                    discount: null,
                    bookCover: null,
                })
                .then((res) => {
                    if (res && res.statusCode === 200) {
                        history.push("/checkout-page");

                    } else {
                        alert("Something went wrong please try again later..");
                    }
                });
        }
    };

    const handletempsave = () => {
        let button = document.getElementById("action-btn");
        button.click();
    };

    const getCustomCharacterStyles = () => {
        const customCharacter = props?.store?.customCharacter || [];

        if (!customCharacter || customCharacter.length == 0) {
            return {};
        }
        let skinStyle = customCharacter.find((o) => o.name == "skin");
        let hairStyle = customCharacter.find((o) => o.name == "hair");
        let tshirtStyle = customCharacter.find((o) => o.name == "tshirt");
        let eyewearStyle = customCharacter.find((o) => o.name == "eyewear");
        let customname = customCharacter.find((o) => o.name == "name");
        let dedication = customCharacter.find((o) => o.name == "dedication");
        let fullname =
            customname &&
            customname.ans &&
            (customname?.ans?.first_name || "") +
            " " +
            (customname?.ans?.last_name || "");
        let firstname = customname && customname.ans && customname.ans.first_name;
        let genders = customCharacter.find((o) => o.name == "gender");
        let currentGender = genders && genders["ans"] && genders["ans"]["gender"];

        return {
            "--skin":
                (skinStyle && skinStyle.ans && skinStyle.ans.skin) || "transparent",
            "--hair":
                (hairStyle && hairStyle.ans && hairStyle.ans.hair) || "transparent",
            "--shoes": "#ae7928",
            "--shirt":
                (tshirtStyle && tshirtStyle.ans && tshirtStyle.ans.tshirt) ||
                "transparent",
            "--short": "#597aab",
            "--glass":
                eyewearStyle && eyewearStyle.ans && eyewearStyle.ans.eyewear == "yes"
                    ? "black"
                    : "none",
            "--name": fullname,
            "--fname": firstname,
            "--currentGender": currentGender,
            "--dedictaion_text": dedication?.ans?.dedication,
        };
    };

    const updateSVGs = () => {
        return new Promise((resolve, reject) => {
            const customCharacter = props.store?.customCharacter || [];
            let hairStyle = customCharacter.find((o) => o.name == "hair-style");
            let { gender, style } = hairStyle.ans["hair-style"].parse();
            let overlayStyle = getCustomCharacterStyles();
            let svgChapStyle =
                gender == "boy"
                    ? {
                        1: {
                            svgViewBox: "50 20 150 200",
                            height: 500,
                            width: 280,
                        },
                        4:
                            style == "02"
                                ? {
                                    svgViewBox: "0 0 590 817",
                                    height: 500,
                                    width: 350,
                                }
                                : style == "03" || style == "04"
                                    ? {
                                        svgViewBox: "0 0 590 817",
                                        height: 500,
                                        width: 350,
                                    }
                                    : {
                                        svgViewBox: "0 0 590 817",
                                        height: 500,
                                        width: 350,
                                    },
                        5: {
                            svgViewBox: "0 0 200 300",
                            height: 350,
                            width: 250,
                        },
                        7: {
                            svgViewBox: "0 0 200 170",
                            height: 310,
                            width: 310,
                        },
                        9:
                            style == "01"
                                ? {
                                    svgViewBox: "0 0 150 110",
                                    height: 140,
                                    width: 140,
                                }
                                : style == "02"
                                    ? {
                                        svgViewBox: "0 0 150 125",
                                        height: 140,
                                        width: 140,
                                    }
                                    : style == "03"
                                        ? {
                                            svgViewBox: "0 0 150 90",
                                            height: 140,
                                            width: 140,
                                        }
                                        : {
                                            svgViewBox: "0 0 150 90",
                                            height: 140,
                                            width: 140,
                                        },
                    }
                    : {
                        1: {
                            svgViewBox: "50 20 150 200",
                            height: 500,
                            width: 280,
                        },
                        4:
                            style == "01"
                                ? {
                                    svgViewBox: "80 75 165 210",
                                    height: 350,
                                    width: 230,
                                }
                                : style == "02"
                                    ? {
                                        svgViewBox: "80 75 165 210",
                                        height: 350,
                                        width: 230,
                                    }
                                    : style == "04" || style == "03"
                                        ? {
                                            svgViewBox: "80 75 165 210",
                                            height: 350,
                                            width: 230,
                                        }
                                        : style == "05"
                                            ? {
                                                svgViewBox: "80 75 165 230",
                                                height: 350,
                                                width: 230,
                                            }
                                            : {
                                                svgViewBox: "80 75 165 230",
                                                height: 350,
                                                width: 230,
                                            },
                        5: {
                            svgViewBox: "0 0 200 300",
                            height: 350,
                            width: 250,
                        },
                        7:
                            style == "02" || style == "04"
                                ? {
                                    svgViewBox: "10 0 200 240",
                                    height: 310,
                                    width: 310,
                                }
                                : style == "03"
                                    ? {
                                        svgViewBox: "10 0 200 210",
                                        height: 310,
                                        width: 310,
                                    }
                                    : style == "05" || style == "06"
                                        ? {
                                            svgViewBox: "0 0 200 170",
                                            height: 310,
                                            width: 310,
                                        }
                                        : {
                                            svgViewBox: "0 0 200 170",
                                            height: 310,
                                            width: 310,
                                        },
                        9:
                            style == "02" || style == "04"
                                ? {
                                    svgViewBox: "0 0 150 160",
                                    height: 140,
                                    width: 140,
                                }
                                : style == "03"
                                    ? {
                                        svgViewBox: "20 0 150 140",
                                        height: 140,
                                        width: 140,
                                    }
                                    : style == "05"
                                        ? {
                                            svgViewBox: "0 0 150 90",
                                            height: 140,
                                            width: 140,
                                        }
                                        : style == "06"
                                            ? {
                                                svgViewBox: "0 0 150 90",
                                                height: 140,
                                                width: 140,
                                            }
                                            : {
                                                svgViewBox: "0 0 150 70",
                                                height: 140,
                                                width: 140,
                                            },
                    };
            api
                .getCustomBookImagesWithContents({
                    gender,
                    style,
                    svgStyle: Object.styleString(overlayStyle),
                    svgViewBox: JSON.stringify(svgChapStyle),
                })
                .then((result) => {
                    let arr = result.data;
                    const svgColor = props.store.customCharacter[3].ans.skin;
                    const shirt = props.store.customCharacter[4].ans.tshirt;
                    const glass =
                        props.store.customCharacter[7].ans.eyewear == "yes"
                            ? "#000"
                            : "none";
                    const hairColor = props.store.customCharacter[6].ans.hair;
                    let customsvg = arr.map((o) => {
                        let svgContent = o.fileContent;
                        let chapter = o.chapter;
                        if (chapter == 9) {
                            let svgStye;
                            if (o.gender == "girl") {
                                if (o.style == "01") {
                                    svgStye = `position: absolute;top: 45px;left: 310px; width:30%`;
                                } else if (o.style == "02") {
                                    svgStye = `position: absolute;top: 50px;left: 280px; width:30%`;
                                } else if (o.style == "03") {
                                    svgStye = `position: absolute;top: 50px;left: 300px; width:30%`;
                                } else if (o.style == "04") {
                                    svgStye = `position: absolute;top: 50px;left: 300px; width:30%`;
                                } else if (o.style == "05") {
                                    svgStye = `position: absolute;top: 50px;left: 300px; width:30%`;
                                } else if (o.style == "06") {
                                    svgStye = `position: absolute;top: 50px;left: 290px; width:30%`;
                                }
                            } else {
                                if (o.style == "01") {
                                    svgStye = `position: absolute;top: 55px;left: 310px; width:30%`;
                                } else if (o.style == "02") {
                                    svgStye = `position: absolute;top: 55px;left: 310px; width:30%`;
                                } else if (o.style == "03") {
                                    svgStye = `position: absolute;top: 55px;left: 310px; width:30%`;
                                } else if (o.style == "04") {
                                    svgStye = `position: absolute;top: 55px;left: 310px; width:30%`;
                                }
                            }
                            let new_svg = svgContent
                                .replaceAll(`width='140'`, `width='126'`)
                                .replaceAll(`height='140'`, `height='126'`)
                                .replaceAll(
                                    `style="fill:var(--skin)"`,
                                    `style="fill:${svgColor}"`
                                )
                                .replaceAll(
                                    `style="fill:var(--hair)"`,
                                    `style="fill:${hairColor}"`
                                )
                                .replaceAll(
                                    `style="fill:var(--shirt)"`,
                                    `style="fill:${shirt}"`
                                )
                                .replaceAll(
                                    `style="fill:var(--glass)"`,
                                    `style="fill:${glass}"`
                                )
                                .replaceAll(`style="fill:var(--shoes)"`, `style="fill:#ae7928"`)
                                .replaceAll(
                                    `style="fill:var(--short)"`,
                                    `style="fill:#597aab"`
                                );
                            return { chapter: chapter, svg: new_svg, stylesvg: svgStye };
                        } else {
                            let new_svg = svgContent
                                .replaceAll(
                                    `style="fill:var(--skin)"`,
                                    `style="fill:${svgColor}"`
                                )
                                .replaceAll(
                                    `style="fill:var(--hair)"`,
                                    `style="fill:${hairColor}"`
                                )
                                .replaceAll(
                                    `style="fill:var(--shirt)"`,
                                    `style="fill:${shirt}"`
                                )
                                .replaceAll(
                                    `style="fill:var(--glass)"`,
                                    `style="fill:${glass}"`
                                )
                                .replaceAll(`style="fill:var(--shoes)"`, `style="fill:#ae7928"`)
                                .replaceAll(
                                    `style="fill:var(--short)"`,
                                    `style="fill:#597aab"`
                                );
                            return { chapter: chapter, svg: new_svg, stylesvg: null };
                        }
                    });
                    setCustomSvg(customsvg);
                    let imgprms = arr.map(
                        (o, i) =>
                            new Promise((imgres, reject) => {
                                let dim = svgChapStyle[o.chapter];
                                o.base64
                                    .svg2png(dim.height, dim.width, [0, 0, dim.width, dim.height])
                                    .then((base64) => {
                                        imgres({
                                            ...o,
                                            svgbase64: o.base64,
                                            base64: base64,
                                            filePath: o.filePath,
                                        });
                                    })
                                    .catch((error) => console.log({ error }));
                            })
                    );
                    Promise.all(imgprms).then((newarr) => {
                        let svgs = newarr.reduce(
                            (o, n) => ({
                                ...o,
                                [n.chapter]: {
                                    base64: n.base64,
                                    svgbase64: n.svgbase64,
                                    filePath: n.filePath,
                                },
                            }),
                            {}
                        );
                        resolve(svgs);
                    });
                })
                .catch(reject);
        });
    };

    return (
        <PreventUnload>
            <div className="">
                <CustomCharacterBookView
                    answer={answer}
                    pages={pages}
                    currentopenpage={currentopenpage}
                />
                <Previewsteps setCurrentopenpage={setCurrentopenpage} />
                <Stepbar
                    name={answer?.name}
                    handleopen={handleClick}
                    preinfoCompleted={preinfoCompleted}
                    addtocart={addtocart}
                    handlePreinfoSave={handlePreinfoSave}
                    savebookforlater={savebookforlater}
                    handletempsave={handletempsave}
                />
            </div>
        </PreventUnload>
    );
};

export default connect(BookManage);
